import { ALTERAR_REGISTROS_POR_PAGINA_CTE_OS } from '../types'

export default function alterarRegistrosPorPaginaCteOs (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_CTE_OS,
    payload: valor
  }
}
